
import {
  getPageLinks,
  getPageFacebookMetaTags,
  getPageTwitterMetaTags,
} from '@/utils/head-helpers';
import Calculator from '@/ui/retirement-calculator/calculator';
import DialogCentered from '@/components/molecules/dialog/dialog-centered';
import FaqSection from '@/components/molecules/faqs/general';
import FIcon from '@/components/atoms/icons/h-icon';
import VideoPopupButton from '@/ui/retirement-calculator/video-popup-button.vue';

export default {
  name: 'PensionGapCalculator',
  components: {
    Calculator,
    DialogCentered,
    FaqSection,
    FIcon,
    VideoPopupButton,
  },

  layout: 'default-without-cta-breadcrumbs',

  async asyncData({ store }) {
    const faqItems = await store.dispatch('faqs/fetchSeoFaqsByCategory', {
      category: 'pension-calculator', // TODO: create enum
    });

    return {
      faqItems,
    };
  },

  data() {
    return {
      tutorialOpen: false,
    };
  },

  head() {
    const routeName = 'retirement-calculator-germany';
    return {
      title: this.$t('seo.title'),
      link: getPageLinks(
        this.routeURL,
        this.$i18n.locale,
        `${this.$config.HOST_NAME}${this.localePath(
          {
            name: routeName,
          },
          'en',
        )}`,
        `${this.$config.HOST_NAME}${this.localePath(
          {
            name: routeName,
          },
          'de',
        )}`,
      ),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$i18n.t('seo.description'),
        },
        ...getPageFacebookMetaTags({
          seoTitle: this.$i18n.t('seo.title'),
          seoDescription: this.$i18n.t('seo.description'),
          pageURL: this.routeURL,
          seoImage: this.$i18n.t('seo.image'),
        }),
        ...getPageTwitterMetaTags({
          seoTitle: this.$i18n.t('seo.title'),
          seoDescription: this.$i18n.t('seo.description'),
          pageURL: this.routeURL,
          seoImage: this.$i18n.t('seo.image'),
        }),
      ],
    };
  },

  computed: {
    routeURL() {
      return `${this.$config.HOST_NAME}${this.$route.path}`;
    },

    isTutorialEnabled() {
      return this.$flagsmith.hasFeature('wip-9081-tutorial-button');
    },

    isTutorialOverlayEnabled() {
      return this.$flagsmith.hasFeature('wip-9081-tutorial-button-use-overlay');
    },
  },
};
